module.exports = __webpack_public_path__ + "img/PRK.ee4004ba.svg";